import axios from 'axios'
import { API_BASE_URL } from './client'
import type { ReportVersionView, ReportViewWithVersions } from '@/lib/types/report'

// Raw client on purpose: apiClient's 401 interceptor triggers handleAuthFailure() → login
// redirect. The public share page must never do that; a bad token is a page-level 404 state.
const publicClient = axios.create({ baseURL: API_BASE_URL, timeout: 30000 })

export const publicReportAPI = {
  getReport: (token: string) => publicClient.get<ReportViewWithVersions>(`/public/reports/${token}`),
  getVersion: (token: string, version: number) =>
    publicClient.get<ReportVersionView>(`/public/reports/${token}/versions/${version}`),
}
